import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { InsightsAuthService } from '@core/services/insights-auth.service';

export const insightsAuthGuard: CanActivateFn = (_route, state) => {
  const router = inject(Router);
  const insightsAuth = inject(InsightsAuthService);
  void insightsAuth.ensureRouteAccess(state.url, router.currentNavigation()?.id ?? -1);
  return true;
};
